import { configureStore } from '@reduxjs/toolkit';
import userReducer from '@app/redux/features/userSlice';
import breadcrumbsReducer from '@app/redux/features/breadcrumbsSlice';
import applicationReducer from '@app/redux/features/applicationSlice';
import sidebarReducer from '@app/redux/features/sidebarSlice';

export const store = configureStore({
  reducer: {
    me: userReducer,
    breadcrumbs: breadcrumbsReducer,
    application: applicationReducer,
    sidebar: sidebarReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
